import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getPageName } from '../../../utils/pageName';
import styles from './search_restriction.module.scss';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { Paper } from '../../../components/paper/Paper';
import { BrandHyperlink } from '../../../components/button/brand/BrandHyperlink';
import { useLoginModal } from '../../../login/useLoginModal';

export const SearchRestriction: FC = () => {
  const sourcePage = getPageName();

  const { openLoginModal } = useLoginModal();

  const source = 'search-restriction';

  return (
    <Paper className={styles.container}>
      <div className={styles.content}>
        <MaterialIcon name="lock" className={styles.icon} />
        <div className={styles.title}>
          <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/1" />
          <br />
          <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/2" />
        </div>
        <div className={styles.startButton}>
          <BrandHyperlink
            large
            href={buildUrlWithParameters('/inscription', {
              source,
              sourcePage,
            })}
            iconLeft="arrow_forward"
          >
            <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/3" />
          </BrandHyperlink>
        </div>
        <div className={styles.connexion}>
          <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/4" />
          <button
            type="button"
            className={styles.connexionLink}
            onClick={() => openLoginModal({ source })}
          >
            <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/5" />
          </button>
        </div>
      </div>
    </Paper>
  );
};
